import { getProperty } from 'customer-data-objects/model/ImmutableModel';
// @ts-expect-error JS file
import { useStoreDependency } from 'general-store';
import SubjectDependency from '../../../../flux/dependencies/SubjectDependency';
// @ts-expect-error JS file
import SubjectType from 'customer-data-objects-ui-components/propTypes/SubjectType';
import EMPTY_LABEL from '../../../../constants/EmptyLabel';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const truncateProp = {
  lineClamp: 2
};
const MiniTicketHighlight = ({
  objectType,
  subjectId
}) => {
  const subject = useStoreDependency(SubjectDependency, {
    objectType,
    subjectId
  });
  const title = getProperty(subject, 'subject');
  return /*#__PURE__*/_jsx(View, {
    overflow: "hidden",
    "data-test-id": "mini-ticket-highlight",
    children: /*#__PURE__*/_jsx(Text, {
      as: "h2",
      typography: "heading-50",
      truncate: truncateProp,
      children: title || EMPTY_LABEL
    })
  });
};
MiniTicketHighlight.propTypes = {
  subject: SubjectType
};
export default MiniTicketHighlight;